<template>
  <!-- don't forget change viewBox and fill params -->

  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3333 9.33326H9.8066L9.61993 9.15326C10.4199 8.21993 10.8333 6.9466 10.6066 5.59326C10.2933 3.73993 8.7466 2.25993 6.87993 2.03326C4.05993 1.6866 1.6866 4.05993 2.03326 6.87993C2.25993 8.7466 3.73993 10.2933 5.59326 10.6066C6.9466 10.8333 8.21993 10.4199 9.15326 9.61993L9.33326 9.8066V10.3333L12.1666 13.1666C12.4399 13.4399 12.8866 13.4399 13.1599 13.1666C13.4333 12.8933 13.4333 12.4466 13.1599 12.1733L10.3333 9.33326ZM6.33326 9.33326C4.67326 9.33326 3.33326 7.99326 3.33326 6.33326C3.33326 4.67326 4.67326 3.33326 6.33326 3.33326C7.99326 3.33326 9.33326 4.67326 9.33326 6.33326C9.33326 7.99326 7.99326 9.33326 6.33326 9.33326Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    color: { type: String, default: '' },
  },
}
</script>
